import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branch-wise-attendance',
  templateUrl: './branch-wise-attendance.component.html',
  styleUrls: ['./branch-wise-attendance.component.scss']
})
export class BranchWiseAttendanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.getBranchWiseAttendance();
  }
  getBranchWiseAttendance()
  {

  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/overview/branch-wise-attendance/branch-wise-attendance.component.ts